import { ChakraComponents as CC } from '@Modules/core/lib/chakra';

export default function PasswordForgot() {
  return (
    <>
      <CC.Box>Password Forgot</CC.Box>
    </>
  );
}
